<template>
    <div id="admin_indexes_page" class="container-fluid">
        <button type="button" class="btn btn-secondary main-button pull-right" data-toggle="modal" data-target="#index_modal">+ Add New Index</button>

        <div class="modal fade" id="index_modal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">{{ editing_index_id ? 'Update Index' : 'Add New Index' }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body">
                        <div class="row">
                            <div class="col-6">
                                <h6>Index Name</h6>
                                <input id="index_name" v-model="index_name" type="text" class="form-control">
                            </div>
                        </div>

                        <div class="row margin-top20">
                            <div class="col-12">
                                <h6>Clients</h6>
                            </div>

                            <div class="col-12 margin-bottom10">
                                <label><p-input type="checkbox" class="p-switch p-slim clients-all" @change="selectAllClients" :checked="selected_clients.length === clients.length">Select all</p-input></label>
                            </div>

                            <template v-for="client in clients">
                                <div class="col-4 margin-bottom5">
                                    <label><p-input v-model="selected_clients" class="p-default p-curve single" type="checkbox" :value="client.id"> {{ client.name }}</p-input></label>
                                </div>
                            </template>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn" data-dismiss="modal">Cancel</button>
                        <button v-if="editing_index_id" @click="updateIndex" :disabled="!index_name" type="button" class="btn btn-success">Update</button>
                        <button v-if="!editing_index_id" @click="addNewIndex" :disabled="!index_name" type="button" class="btn btn-success">Add</button>
                    </div>
                </div>
            </div>
        </div>

        <v-client-table :data="tableData" :columns="columns" :options="options">
            <div slot="actions" slot-scope="props" class="text-right">
                <button @click="edit(props.row)" class="btn btn-info reverse">Edit</button>
                <button @click="remove(props.row.id)" class="btn btn-danger reverse">Delete</button>
            </div>
        </v-client-table>

        <div class="text-center">
            <button @click="$router.go(-1)" type="button" class="btn btn-info">Back</button>
        </div>
    </div>
</template>

<script>
    export default {
        created() {
            this.fetchServerData();

            const self = this;

            $(document).off('hidden.bs.modal', '#index_modal').on('hidden.bs.modal', '#index_modal', function() {
                self.editing_index_id = null;
                self.index_name       = '';
                self.selected_clients = [];
            });
        },

        data() {
            return {
                index_name:       '',
                clients:          [],
                selected_clients: [],
                editing_index_id: null,

                columns: ['name', 'actions'],
                tableData: [],
                options: {
                    headings: {
                        name:    'Index Name',
                        actions: ''
                    },
                    sortable: ['name'],

                    perPage: 20,
                    perPageValues: [],
                    texts: {
                        count: 'Showing {from} to {to} of {count} indexes|{count} indexes|One index',
                        filter: '',
                        filterPlaceholder: 'Search indexes...',
                        noResults: 'No matching indexes'
                    },
                    skin: 'table'
                }
            }
        },

        methods: {
            fetchServerData() {
                axios.all([
                    axios.get('/api/admin/indexes'),
                    axios.get('/api/clients')
                ])
                .then(axios.spread((indexes, clients) => {
                    this.tableData = indexes.data;
                    this.clients   = clients.data;
                }));
            },

            selectAllClients(isChecked) {
                this.selected_clients = [];

                if (isChecked) {
                    _.each(this.clients, client => {
                        this.selected_clients.push(client.id);
                    });
                }
            },

            addNewIndex() {
                $('#index_modal').modal('hide');

                axios.post('/api/admin/indexes', {
                    index_name:       this.index_name,
                    selected_clients: JSON.stringify(this.selected_clients)
                })
                .then(() => {
                    this.$notify({
                        type: 'success',
                        text: 'Index has been successfully added.'
                    });

                    this.fetchServerData();
                });
            },

            edit(row) {
                this.editing_index_id = row.id;
                this.index_name       = row.name;
                this.selected_clients = !!row.client_ids ? _.map(row.client_ids.split(','), clientId => parseInt(clientId)) : [];

                $('#index_modal').modal('show');
            },

            updateIndex(id) {
                $('#index_modal').modal('hide');

                axios.put(`/api/admin/indexes/${this.editing_index_id}`, {
                    index_name:       this.index_name,
                    selected_clients: JSON.stringify(this.selected_clients)
                })
                .then(() => {
                    this.$notify({
                        type: 'success',
                        text: 'Index has been successfully updated.'
                    });

                    this.fetchServerData();
                });
            },

            remove(id) {
                this.confirmation('Are you sure you want to delete this index?', () => {
                    axios.delete(`/api/admin/indexes/${id}`).then(() => {
                        this.$notify({
                            type: 'success',
                            text: 'Index has been successfully deleted.'
                        });

                        this.fetchServerData();
                    });
                });
            }
        }
    }
</script>

<style lang="scss">
    @import '~@/_variables.scss';

    #admin_indexes_page {
        .VueTables__table {
            table-layout: fixed;
        }

        #index_modal {
            label {
                font-weight: 500;
            }

            .pretty.p-default input:checked ~ .state label::after {
                background-color: $info !important;
            }

            .pretty.p-switch input:checked ~ .state label::after {
                background-color: $info !important;
            }
        }
    }
</style>
